/*
	OneMobileMenu 1.0.0 Usage
	yang @onerockwell
	
	
	
*/

import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

"use strict";

var OneMobileMenuView = Backbone.View.extend({
		
	initialize: function (settings) {
		var self = this;
		self.$mobileNav = self.$el;
	},

	events: {
		'click [data-trigger]' : function(e){
			e.preventDefault();
			var self = this;
			var $trigger = $(e.currentTarget);
			var target = $trigger.data('trigger');
			var $target = self.$mobileNav.find('[data-target="' + target + '"]');
			
			if ( $target.length ) {

				if($trigger.hasClass('active')){
					// self.$mobileNav.removeClass('slide-menu-opened');
					$target.removeClass('active');
					$trigger.removeClass('active');
				}else{
					$trigger.addClass('active');
					$target.addClass('active');
					// self.$mobileNav.addClass('slide-menu-opened');
					
					if ($target.find('input').length) {
						setTimeout(function(){ $target.find('input').focus(); },100);
					}
				}

			}
		},
		'click .back-to' : function(e){
			e.preventDefault();
			var self = this;
			var $backToBtn = $(e.currentTarget);
			var $target = $backToBtn.parents('.dropdown');
			var trigger = $target.data('target');
			var $trigger = self.$mobileNav.find('[data-trigger="' + trigger + '"]');
			
			self.$mobileNav.removeClass('slide-menu-opened');
			$target.removeClass('active');
			$trigger.removeClass('active');
		}
	},
	
	destroy: function() {
		var self = this;
		self.undelegateEvents();
	}

});

var OneMobileMenu = {
	init: function (settings) {
		return new OneMobileMenuView(settings);
	}
}

export default OneMobileMenu;